import type { User } from "./authAtoms";

const AUTH_TOKEN_KEY = "excalidraw-auth-token";
const AUTH_USER_KEY = "excalidraw-auth-user";

/**
 * Save authentication token to localStorage
 */
export const saveAuthToken = (token: string): void => {
  try {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  } catch (error) {
    console.error("Failed to save auth token:", error);
  }
};

/**
 * Get authentication token from localStorage
 */
export const getAuthToken = (): string | null => {
  try {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  } catch (error) {
    console.error("Failed to get auth token:", error);
    return null;
  }
};

/**
 * Remove authentication token from localStorage
 */
export const removeAuthToken = (): void => {
  try {
    localStorage.removeItem(AUTH_TOKEN_KEY);
  } catch (error) {
    console.error("Failed to remove auth token:", error);
  }
};

/**
 * Save user data to localStorage
 */
export const saveAuthUser = (user: User): void => {
  try {
    localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
  } catch (error) {
    console.error("Failed to save auth user:", error);
  }
};

/**
 * Get user data from localStorage
 */
export const getAuthUser = (): User | null => {
  try {
    const userJson = localStorage.getItem(AUTH_USER_KEY);
    if (!userJson) {
      return null;
    }
    return JSON.parse(userJson);
  } catch (error) {
    console.error("Failed to get auth user:", error);
    return null;
  }
};

/**
 * Remove user data from localStorage
 */
export const removeAuthUser = (): void => {
  try {
    localStorage.removeItem(AUTH_USER_KEY);
  } catch (error) {
    console.error("Failed to remove auth user:", error);
  }
};

/**
 * Clear all authentication data from localStorage
 */
export const clearAuthData = (): void => {
  removeAuthToken();
  removeAuthUser();
};

/**
 * Check if user has valid session data in localStorage
 */
export const hasStoredSession = (): boolean => {
  return !!(getAuthToken() && getAuthUser());
};
